module.exports = __webpack_public_path__ + "media/assets/images/layout/header-bg-dark-22d74019dce760f944fa140a39a4ef58.png";